<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>請求一覧</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="顧客"
          dense
          v-model="params.search"
          @change="getInvoices"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="ステータス"
          dense
          :items="$store.getters.invoiceStatus"
          item-text="name"
          item-value="id"
          v-model="params.status"
          @change="getInvoices"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="請求日（FROM）"
              readonly
              dense
              v-on="on"
              v-model="params.date_of_issue__gte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.date_of_issue__gte"
            @change="getInvoices"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="請求日（TO）"
              dense
              readonly
              v-on="on"
              v-model="params.date_of_issue__lte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.date_of_issue__lte"
            @change="getInvoices"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="契約対象期間（FROM）"
              dense
              readonly
              v-on="on"
              v-model="params.enddate__gte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.enddate__gte"
            @change="getInvoices"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="契約対象期間（TO）"
              dense
              readonly
              v-on="on"
              v-model="params.startdate__lte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.startdate__lte"
            @change="getInvoices"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="購読コード"
          dense
          v-model="params.subscription__cd__contains"
          @change="getInvoices"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-text-field
          label="請求コード"
          dense
          v-model="params.cd__contains"
          @change="getInvoices"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品カテゴリ"
          :items=$store.getters.productCategories
          item-text="name"
          item-value="id"
          dense
          v-model="params.productdetail__product__productcategory"
          @change="getInvoices"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品"
          :items="search_products"
          item-text="name"
          item-value="id"
          dense
          v-model="params.productdetail__product"
          @change="getInvoices"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品明細"
          dense
          :items="search_productdetails"
          item-text="name"
          item-value="id"
          v-model="params.productdetail"
          @change="getInvoices"
        >
        </v-select>
      </v-col>
      <v-col
        cols="3"
      >
        <v-switch
          label="削除データも表示"
          v-model="contain_deleted"
          dense
          @change="getInvoices"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="download"
        >
          対象一括ダウンロード
        </v-btn>
      </v-col>
      <v-col
        cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="download_dialog = true"
        >
          データダウンロード
        </v-btn>
        <v-dialog v-model="download_dialog" persistent>
          <v-card>
            <v-card-title>
              データダウンロード
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-select
                      label="入金状態"
                      dense
                      :items=payment_status_list
                      item-text="name"
                      item-value="id"
                      v-model="params.download_payment_status"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="data_download"
                    class="white--text red"
                    >ダウンロード</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="download_dialog = false"
                    color="default">キャンセル</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getInvoices"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditInvoice', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="$router.push({ name: 'EditSubscription', params: {id: item.subscription.id}})"
              >
                <v-list-item-title
                >購読情報へ</v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
                v-if="!item.is_deleted"
              >
                <v-list-item-title
                >削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="請求書削除"
          message="請求書を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteInvoice"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      headers: [
        {text: "顧客名称", value: "list_display_name"},
        {text: "商品", value: "productdetail.name"},
        {text: "金額", value: "price"},
        {text: "請求日", value: "date_of_issue"},
        {text: "発行回数", value: "publish_count"},
        {text: "ステータス", value: "status.name"},
        {text: "操作", value: "action", width: "130px"},
      ],
      items: [],
      params: {
        search: '',
        cd: '',
        subscription__cd: '',
        status: '',
        date_of_issue__lte: '',
        date_of_issue__gte: '',
        enddate__gte: '',
        startdate__lte: '',
        productdetail__product__productcategory: '',
        productdetail__product: '',
        productdetail: '',
        search_products: [],
        search_productdetals: [],
        is_deleted: false,
        download_payment_status: '',
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      search_products: [],
      search_productdetails: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      deleteItem: {},
      contain_deleted: false,
      download_dialog: false,
      payment_status_list: [
        {id: 1, name: 'すべて'},
        {id: 2, name: '契約対象期間(TO)以前に入金あり'},
        {id: 3, name: '契約対象期間(TO)以前に入金なし'},
      ],
    }
  },
  watch: {
    'params.productdetail__product__productcategory': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
            {
              params: {'productcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_products = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_products = []
      }
    },
    'params.productdetail__product': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_productdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_productdetails = [];
      }
    },
    contain_deleted: function() {
      if (this.contain_deleted) {
        this.params.is_deleted = null;
      } else {
        this.params.is_deleted = false;
      }
    }
  },
  methods: {
    async getInvoices() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteInvoice() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getInvoices();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    },
    async download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/pdf_list/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice_list.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
    async data_download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/list_download/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice_list.xlsx");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        this.download_dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>
<style scoped>
.v-data-table {
  white-space : pre-wrap;
}
</style>